var event_cards = ( function( $ ) {

	var $toggles;

	var _init = function() {
		$toggles = $( '.event-days-toggle' );

		$toggles.each( function( index, item ) {
			var $item = $( item );

			if ( $item.hasClass( 'multiple-days' ) || $item.hasClass( 'force-enable-toggle' ) ) {
				_setup_days_toggle( $item );
			}
		} );
	};

	var _setup_days_toggle = function( $toggle ) {
		var $toggle_dropdown = $toggle.find( '.toggle-dropdown' );

		$toggle_dropdown.on( 'click', e => _toggle_days( e, $toggle ) );
		$toggle_dropdown.keypress( function( e ) {
			if ( e.keyCode == 13 ) { // Enter
				_toggle_days( e, $toggle );
			}
		} );
	};

	var _toggle_days = function( e, $toggle ) {
		e.preventDefault();
		$toggle.toggleClass( 'open' );
		$toggle.find( '.days-dropdown' ).slideToggle();
	};

	if ( $( '.event-days-toggle' ).length > 0 ) {
		$( document ).ready( _init );
	}

} ) ( jQuery );

module.exports = event_cards;